// @dx utility
import { createClient } from "@refinedev/supabase";
import { getActiveSpan, spanToTraceHeader, spanToBaggageHeader } from "@sentry/react";
import { instrumentSupabaseClient } from "@shared/supabase/instrumented";
import { feSupabaseErrorReporter } from "./supabaseErrorReporter";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

export const supabaseClient = instrumentSupabaseClient(
  createClient(SUPABASE_URL, SUPABASE_KEY, {
    db: {
      schema: "public",
    },
    auth: {
      persistSession: true,
    },
  }),
  feSupabaseErrorReporter,
);

// Wrap functions.invoke to propagate W3C trace context (traceparent + baggage)
// to all edge function calls without changing any call site.
const _invoke = supabaseClient.functions.invoke.bind(supabaseClient.functions);
supabaseClient.functions.invoke = (functionName, options) => {
  const span = getActiveSpan();
  const traceHeaders: Record<string, string> = {};
  if (span) {
    const traceparent = spanToTraceHeader(span);
    const baggage = spanToBaggageHeader(span);
    if (traceparent) traceHeaders["traceparent"] = traceparent;
    if (baggage) traceHeaders["baggage"] = baggage;
  }
  return _invoke(functionName, {
    ...options,
    headers: { ...traceHeaders, ...(options?.headers ?? {}) },
  });
};